import React from 'react';
import { ShieldCheck, Lock, Globe } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-6 pb-2 px-3 md:pt-12 md:pb-4" data-id="element-179">
      <div className="max-w-xl mx-auto text-center" data-id="element-180">
        <div className="animate-fadeInUp" data-id="element-181">
          {/* Top Badge */}
          <div className="inline-flex items-center gap-2 bg-black border border-brand-yellow/50 px-4 py-2 rounded-full mb-4" data-id="element-182">
            <span className="text-sm font-bold text-brand-yellow tracking-wide uppercase" data-id="element-183">
              🧭 GUÍA REAL PARA ESTA ETAPA
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="md:text-5xl font-black mb-3 text-white text-[24px]" data-id="element-184">
            👉 Lo que nadie te dijo sobre la vejez de tus padres
          </h1>

          {/* Subheadline */}
          <p className="md:text-xl italic mb-4 text-[14px] text-[#DDDDDD] font-[400]" data-id="element-185">
            Un sistema claro para acompañar esta etapa sin miedo, sin dudas y
            con más tranquilidad
          </p>

          {/* Product image */}
          <div className="w-full mb-4 px-2" data-id="element-186">
            <img src="https://cdn.magicpatterns.com/uploads/d48U4XX53XD9onGRfyYgfk/MOCKUP_600x.png" alt="Mega Pack Afrontar la Vejez de Tus Padres" width={600} height={450} className="w-full h-auto drop-shadow-2xl cursor-pointer" fetchPriority="high" loading="eager" decoding="sync" onClick={() => document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-187" />
          </div>

          {/* Middle text - Cyan/Blue */}
          <div className="mb-4 space-y-4" data-id="element-188">
            <p className="md:text-xl text-[14px] text-[#2BD2F3] font-[400]" data-id="element-189">
              Nadie te enseñó cómo hacer esto... pero puedes aprender a hacerlo
              bien... Antes de que sea demasiado tarde
            </p>
          </div>

          {/* Bottom highlight text */}
          <p className="text-white md:text-lg italic mb-6 max-w-sm mx-auto font-[300] text-[12px]" data-id="element-190">
            Toma decisiones claras, reduce el conflicto familiar y acompaña esta
            etapa con más orden, calma y seguridad desde las primeras semanas.
          </p>

          {/* Full-width CTA */}
          <CTAButton text="👉 QUIERO MI MEGAPACK AHORA" className="w-full md:w-auto mx-auto mb-5 py-4 px-8 text-sm md:text-lg font-black rounded-xl uppercase" data-id="element-191" />

          {/* Trust badges - updated colors */}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] md:text-xs text-gray-400 font-medium" data-id="element-192">
            <div className="flex items-center gap-1.5" data-id="element-193">
              <ShieldCheck size={14} className="text-[#3B82F6]" data-id="element-194" />
              <span data-id="element-195">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-196">
              <Lock size={14} className="text-[#FBBF24]" data-id="element-197" />
              <span data-id="element-198">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-199">
              <Globe size={14} className="text-[#3B82F6]" data-id="element-200" />
              <span data-id="element-201">Pagas en la moneda de tu país</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}